var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.5 56.5H14.498C13.9676 56.5 13.4589 56.2893 13.0838 55.9142C12.7088 55.5392 12.498 55.0304 12.498 54.5V10.5C12.498 9.96957 12.7088 9.46086 13.0838 9.08579C13.4589 8.71071 13.9676 8.5 14.498 8.5H38.5L52.5 22.5V54.5C52.5 54.7626 52.4483 55.0227 52.3478 55.2654C52.2473 55.508 52.0999 55.7285 51.9142 55.9142C51.7285 56.0999 51.508 56.2473 51.2654 56.3478C51.0227 56.4483 50.7626 56.5 50.5 56.5Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5 8.5V23.5H52.502",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.b02191319486a6fa09c88a8a47a61661.svg";
export { ForwardRef as ReactComponent };